<template>
  <v-layout row>
    <v-flex xs12 sm10 order-xs2 style="position: relative;">
      <div class="chat-container" v-if="!loading" ref="chatContainer">
        <message :index="index" @imageLoad="scrollToEnd" />
      </div>
      <emoji-picker :show="emojiPanel" @close="toggleEmojiPanel" @click="addEmoji" />
      <div class="typer">
        <input type="text" placeholder="Type here..." @keyup.enter="sendMessage" v-model="content">
        <v-btn icon class="blue--text emoji-panel" @click="selectFile">
          <v-icon>attach_file</v-icon>
					<input
						type="file"
						style="display: none"
						ref="image"
						accept="image/*"
						@change="onFilePicked"
					>
        </v-btn>
        <v-btn icon class="blue--text emoji-panel" @click="toggleEmojiPanel">
          <v-icon>mood</v-icon>
        </v-btn>
      </div>
    </v-flex>
    <v-flex sm2 order-xs1 class="scrollable">
      <chats />
    </v-flex>
  </v-layout>
</template>

<script>
  import Message from './Message.vue'
  import EmojiPicker from './EmojiPicker.vue'
  import Chats from './Chats.vue'

  export default {

    props: {
      index: String
    },
    data () {
      return {
        content: '',
        chatMessages: [],
        replyId: '',
        emojiPanel: false,
        loading: false,
        totalChatHeight: 0,
        fileData: '',
        fileName: '',
        fileUrl: '',
      }
    },
    mounted () {
      this.loadChat()
    },
    components: {
      'message': Message,
      'emoji-picker': EmojiPicker,
      'chats': Chats
    },
    computed: {
      chat () {
        return this.$store.getters.chats[this.index]
      },
      chats () {
        return this.$store.getters.chats
      },
      user () {
        return this.$store.getters.user
      },
      messages () {
        return this.chat ? this.$store.getters.messages(this.chat.chatId) : []
      },
      onChildAdded () {
        const that = this
        let onChildAdded = function (snapshot, newMessage = true) {
          let message = snapshot.val()
          message.key = snapshot.key
          /*eslint-disable */
          var urlPattern = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/ig
          /*eslint-enable */
          message.content = message.content
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;')
          message.content = message.content.replace(urlPattern, "<a href='$1'>$1</a>")
          if (!newMessage) {
            that.chatMessages.unshift(that.processMessage(message))
            that.scrollTo()
          } else {
            that.chatMessages.push(that.processMessage(message))
            that.scrollToEnd()
          }
        }
        return onChildAdded
      }
    },
    watch: {
      '$route.params.index' (newId, oldId) {
        this.loadChat()
      },
      messages () {
        this.scrollToEnd()
      }
    },

    methods: {
      async loadChat () {
        this.loading = true
        
        if (this.chat) {
          const chatId = this.chat.chatId

          this.$store.dispatch('openChat', { chatId })

          const lastMessage = this.messages[this.messages.length - 1]
          const lastId = lastMessage ? lastMessage.messageId || 0 : 0

          // console.log('load chat messages from', lastId)
          await this.$store.dispatch('loadNewMessages', { chatId, messageId: lastId })
        }
        this.loading = false
        this.scrollToEnd()
      },

      sendMessage () {
        if (this.content !== '' && this.chat) {
          const data = {
            chatId: this.chat.chatId,
            reply: null,
            type: 'text',
            data: { text: this.content }
          }
          this.$store.dispatch('sendMessage', data)
          this.content = ''
        }
      },

      scrollToEnd () {
        this.$nextTick(() => {
          var container = this.$el.querySelector('.chat-container')
          if (!container) { return }
          container.scrollTop = container.scrollHeight
        })
      },

      addEmoji (emoji) {
        this.content += emoji.value
      },

      toggleEmojiPanel () {
        this.emojiPanel = !this.emojiPanel
      },

      selectFile() {
        this.$refs.image.click ()
      },

      onFilePicked (e) {
        const files = e.target.files
        if(files[0] !== undefined) {
          this.fileName = files[0].name
          console.log('file selected', this.fileName) 
          if(this.fileName.lastIndexOf('.') <= 0) {
            return
          }
          const fr = new FileReader ()
          fr.readAsDataURL(files[0])
          fr.addEventListener('load', () => {
            this.fileUrl = fr.result
            this.fileData = files[0] // this is an image file that can be sent to server...
            const message = {
              chatId: this.chat.chatId,
              reply: null,
              type: 'file',
              data: { name: this.fileName }
            }
            this.$store.dispatch('sendFile', { message, fileData: this.fileData })
          })
        } else {
          this.fileName = ''
          this.fileData = ''
          this.fileUrl = ''
        }
      }
    }
  }
</script>

<style>
  .scrollable {
    overflow-y: auto;
    height: calc(100vh - 4.6rem);
  }
  .typer{
    box-sizing: border-box;
    display: flex;
    align-items: center;
    bottom: 0;
    height: 4.9rem;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 -5px 10px -5px rgba(0,0,0,.2);
  }

  .typer input[type=text]{
    position: absolute;
    left: 7rem;
    padding: 1rem;
    width: 80%;
    background-color: transparent;
    border: none;
    outline: none;
    font-size: 1.25rem;
  }
  .chat-container{
    box-sizing: border-box;
    height: calc(100vh - 9.5rem);
    overflow-y: auto;
    padding: 10px;
    background-color: #f2f2f2;
  }
  .message{
    margin-bottom: 3px;
  }
  .message.own{
    text-align: right;
  }
  .message.own .content{
    background-color: lightskyblue;
  }
  .chat-container .username{
    font-size: 18px;
    font-weight: bold;
  }
  .chat-container .content{
    padding: 8px;
    background-color: lightgreen;
    border-radius: 10px;
    display:inline-block;
    box-shadow: 0 1px 3px 0 rgba(0,0,0,0.2), 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12);
    max-width: 50%;
    word-wrap: break-word;
    }
  @media (max-width: 480px) {
    .chat-container .content{
      max-width: 60%;
    }
  }

</style>
